import {applyInteractionId} from '@servicenow/ui-metrics';
import {CONFIG, DISPATCH, PRESENTATIONAL} from '../symbols';
import {emitNowUiEvent, getHostVariables} from '../utils';
import {ACTION_DISPATCHED} from '../constants';

export function createConditionalDispatch(host) {
	const hostVariables = getHostVariables(host);

	return function dispatch(type, payload, meta, error) {
		applyInteractionId(meta);
		if (!hostVariables[PRESENTATIONAL] && hostVariables[CONFIG].shouldDispatch[type])
			return hostVariables[DISPATCH](type, payload, meta, error);
		emitNowUiEvent(ACTION_DISPATCHED, {host, action: {type, payload, meta, error}});
	};
}
